import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { PrivateMessageQueryType } from '../../../../models/privateMessage'
import { MessagingPageService } from '../../../../pages/messaging/messaging/messaging-page.service'
import { MessageDirection } from '../../private-message-list-wrapper/private-message-list-wrapper.component'

export type ToggleablePrivateMessageType = PrivateMessageQueryType.direct | PrivateMessageQueryType.feedback

@Component({
  selector: 'app-private-message-type-toggle',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './private-message-type-toggle.component.html',
  styleUrls: ['./private-message-type-toggle.component.scss'],
})
export class PrivateMessageTypeToggleComponent implements OnInit {
  private messagingService = inject(MessagingPageService)
  private destroyRef = inject(DestroyRef)

  TAG = 'PrivateMessageTypeToggleComponent'

  @Input() messageDirection: MessageDirection = 'inbound'

  toggleValue = false
  messageType: ToggleablePrivateMessageType = PrivateMessageQueryType.feedback
  MsgType = PrivateMessageQueryType

  ngOnInit(): void {
    const type$ =
      this.messageDirection === 'inbound' ? this.messagingService.inboundMsgType$ : this.messagingService.outboundMsgType$

    type$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((type) => {
      this.messageType = type as ToggleablePrivateMessageType
      this.toggleValue = type === PrivateMessageQueryType.direct
    })
  }

  toggleChanged(isFeedback: boolean): void {
    console.log(this.TAG, 'toggleValue', this.toggleValue)
    this.changeMessageType(!isFeedback)
  }

  changeMessageType(isFeedback: boolean): void {
    setTimeout(() => {
      this.messageType = isFeedback ? PrivateMessageQueryType.feedback : PrivateMessageQueryType.direct
      if (this.messageDirection === 'inbound') {
        this.messagingService.setPrivateMessageType(this.messageType)
      } else {
        this.messagingService.setOutboundPrivateMessageType(this.messageType)
      }
    })
  }
}
